import React from 'react';
import { Descriptions, Empty, Table } from 'antd';
import ReportSection from './components/ReportSection';
import { renderPlainValue } from './trans.effect';
import { toBuerOverdueViewModel } from './struct';

interface Props {
  data: any;
}

const BuerOverdueTab: React.FC<Props> = ({ data }) => {
  if (!data) return <Empty description="暂无数据" />;

  const vm = toBuerOverdueViewModel(data);
  if (!vm) return <Empty description="数据解析失败" />;

  const resultCodeMap: Record<string, string> = {
    '1': '逾期未还款',
    '2': '正常履约',
    '3': '逾期又还款',
    '4': '无法确认',
    U: '无法确认',
  };

  const resultCodeKey = String(vm.resultCode ?? '').trim();
  const resultCodeText = resultCodeKey && resultCodeMap[resultCodeKey] ? resultCodeMap[resultCodeKey] : renderPlainValue(vm.resultCode);

  return (
    <div style={{ padding: 20 }}>
      <>
        <ReportSection
          title="探查现状"
          extra={
            <>
              <span>生产时间: {vm.header.createdTime}</span>
              <span>有效期至: {vm.header.validTime}</span>
            </>
          }
        >
          <Descriptions column={1} bordered size="small">
            <Descriptions.Item
              label="探查结论"
              labelStyle={{ width: 120, whiteSpace: 'nowrap' }}
              contentStyle={{ width: 'auto' }}
            >
              {resultCodeText}
            </Descriptions.Item>
          </Descriptions>
        </ReportSection>

        <ReportSection title="逾期现状">
          <Table
            size="small"
            bordered
            pagination={false}
            locale={{ emptyText: '-' }}
            dataSource={[
              {
                key: 'row',
                max_overdue_days: vm.overdueStatus.maxOverdueDays,
                max_overdue_amt: vm.overdueStatus.maxOverdueAmt,
                latest_overdue_time: vm.overdueStatus.latestOverdueTime,
              },
            ]}
            columns={[
              { title: '最长逾期天数', dataIndex: 'max_overdue_days', key: 'max_overdue_days', align: 'center', render: (v: any) => renderPlainValue(v) },
              { title: '最大逾期金额', dataIndex: 'max_overdue_amt', key: 'max_overdue_amt', align: 'center', render: (v: any) => renderPlainValue(v) },
              { title: '最近逾期时间', dataIndex: 'latest_overdue_time', key: 'latest_overdue_time', align: 'center', render: (v: any) => renderPlainValue(v) },
            ]}
          />
        </ReportSection>

        <ReportSection title="履约现状">
          <Table
            size="small"
            bordered
            pagination={false}
            locale={{ emptyText: '-' }}
            dataSource={[
              {
                key: 'row',
                count_performance: vm.performanceStatus.countPerformance,
                max_performance_amt: vm.performanceStatus.maxPerformanceAmt,
                latest_performance_time: vm.performanceStatus.latestPerformanceTime,
              },
            ]}
            columns={[
              { title: '履约次数', dataIndex: 'count_performance', key: 'count_performance', align: 'center', render: (v: any) => renderPlainValue(v) },
              { title: '最大履约金额', dataIndex: 'max_performance_amt', key: 'max_performance_amt', align: 'center', render: (v: any) => renderPlainValue(v) },
              { title: '最近履约时间', dataIndex: 'latest_performance_time', key: 'latest_performance_time', align: 'center', render: (v: any) => renderPlainValue(v) },
            ]}
          />
        </ReportSection>

        <ReportSection title="机构现状" style={{ marginBottom: 0 }}>
          <Table
            size="small"
            bordered
            pagination={false}
            locale={{ emptyText: '-' }}
            dataSource={[
              {
                key: 'row',
                currently_overdue: vm.agencyStatus.currentlyOverdue,
                currently_performance: vm.agencyStatus.currentlyPerformance,
                acc_exc: vm.agencyStatus.accExc,
                acc_sleep: vm.agencyStatus.accSleep,
              },
            ]}
            columns={[
              { title: '当前逾期机构数', dataIndex: 'currently_overdue', key: 'currently_overdue', align: 'center', render: (v: any) => renderPlainValue(v) },
              { title: '当前履约机构数', dataIndex: 'currently_performance', key: 'currently_performance', align: 'center', render: (v: any) => renderPlainValue(v) },
              { title: '还款异常机构数', dataIndex: 'acc_exc', key: 'acc_exc', align: 'center', render: (v: any) => renderPlainValue(v) },
              { title: '睡眠机构数', dataIndex: 'acc_sleep', key: 'acc_sleep', align: 'center', render: (v: any) => renderPlainValue(v) },
            ]}
          />
        </ReportSection>
      </>
    </div>
  );
};

export default BuerOverdueTab;
